import { LabelType } from './label-type';

export interface Scan {
  labelType?: LabelType | null;
  data: string;
  timestamp: string;
}
